<template>
  <q-card
    flat
    bordered
    class="panel-padding-phone bg-grey-1 column items-center"
    style="height: 100%"
  >
    <q-card-section
      class="title-phone column items-center full-width "
      style="height: 100%"
    >
      <p class="title-phone row items-center justify-center full-width q-mb-md">
        Telefones do cliente
      </p>

      <div
        class="columns items-center justify-center full-width scroll"
        style=" max-height: 80%"
      >
        <div
          class="column"
          v-for="(phone, index) in phoneList"
          :key="index"
        >
          <q-btn
            flat
            no-caps
            padding="none"
            color="white"
          >
            <q-tooltip v-if="isAnonymizationEnabled">
              Número anonimizado por política de segurança
            </q-tooltip>
            <q-tooltip v-else>
              Discar para esse número
            </q-tooltip>
            <div
              class=" full-width panel-box-phone row items-center justify-between q-px-sm cursor-pointer"
              :class="statusBtn(phone)"
              outline
              :label="phone.number"
              @click="handleStartCall(phone.formatNumber)"
            >
              <div :style="{fontWeight: 500, color: '#000'}">
                {{ displayPhone(phone.number) }}
              </div>
              <div class="row items-center">
                <div
                  v-if="showBadge(phone)"
                  class="button-badge display-badge row items-center justify-center"
                  :style="{ fontColor: statusColor(phone), backgroundColor: statusColor(phone)}"
                >
                  <div class="display-badge">
                    {{ badgeText(phone) }}
                  </div>
                </div>
                <phone-outgoing-outline :color="statusColor(phone)" />
              </div>
            </div>
          </q-btn>
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import phoneOutgoingOutline from '@/assets/icons/phoneOutgoingOutline.svg'
import { formatPhone, anonymizePhone } from '@/components/utils/phones'
import api from '@/libs/api'

export default {
  components: { phoneOutgoingOutline },

  props: {
    phoneList: {},
    previewContact: {}
  },

  data () {
    return {
      isLoading: false,
      blockButton: false,
      phoneBoxWidth: null
    }
  },

  computed: {
    ...mapState({
      isPaused: ({ agentModule }) => Boolean(agentModule?.session?.agent?.paused),
      isNotConnected: ({ sipModule }) => !sipModule.sipConnected,
      previewContacts: ({ attendanceModule }) => attendanceModule.preview.status
    }),

    ...mapGetters({
      queueProperties: 'agentModule/queueProperties'
    }),

    queueId () {
      return this.$route.params.queueId
    },

    displayPhone () {
      return (phone) => {
        const queueProps = this.queueProperties(this.queueId)
        const shouldAnonymize = queueProps?.anonymizePhone === 'yes'

        if (shouldAnonymize) {
          return anonymizePhone(phone)
        }

        return formatPhone(phone)
      }
    },

    isAnonymizationEnabled () {
      const queueProps = this.queueProperties(this.queueId)
      return queueProps?.anonymizePhone === 'yes'
    }

  },

  methods: {

    showBadge (phone) {
      return ['COMPLETED', 'DISCARDED', 'DIALED'].includes(phone.status)
    },

    ...mapActions({
      call: 'sipModule/call',
      setPreviewStatus: 'attendanceModule/setPreviewStatus'
    }),

    async handleStartCall  (contactPhone) {
      if (this.isPaused || this.blockButton) return
      this.blockButton = true
      if (this.isNotConnected) return
      this.$emit('isDialing', true)
      this.setPreviewStatus({ previewStatus: 'DIALING', contactStatus: 'DIALED', phoneStatus: 'DIALED', phone: contactPhone, queueId: this.queueId })
      if (this.previewContactStatus !== 'DIALED') await api.postPreviewStatus(this.previewContact.id, 'DIALED')
      this.call([contactPhone, this.queueId])
    },

    statusColor (item) {
      if (item.status === 'COMPLETED') return '#12B361'
      if (item.status === 'DISCARDED') return '#FF0000'
      if (item.status === 'DIALED') return '#165A9F'
      return '#B5B5B5'
    },

    badgeText (item) {
      if (item.status === 'COMPLETED') return 'Completado'
      if (item.status === 'DISCARDED') return 'Descartado'
      if (item.status === 'DIALED') return 'Discado'
      return ''
    },

    statusBtn (item) {
      if (item.status === 'COMPLETED') return 'phone-completed'
      if (item.status === 'DISCARDED') return 'phone-discarded'
      return 'phone-default'
    }

  }

}

</script>
<style lang="sass" scoped>

.panel-box-phone
  height: 40px
  border-radius: 6px
  font-size: 12px
  margin-bottom: 10px

.phone-completed
  border: 1px solid #919191
  color: #fff
  &:hover
    border: 2px solid #165A9F
    background-color: #f5f5f5

.phone-discarded
  border: 1px solid #919191
  color: #fff
  &:hover
    border: 2px solid #165A9F
    background-color: #f5f5f5

.phone-default
  color: #fff
  border: 1px solid #919191
  &:hover
    border: 2px solid #165A9F
    background-color: #f5f5f5

.preview-label-phone
  border-radius: 5px
  font-size: 12px

.title-phone
  font-weight: 500
  font-size: 20px
  color: #000000
  border-bottom: 1px solid #C5C5C5

.button-badge
  width: 90px
  margin-right: 5px
  border-radius: 6px

@media only screen and (max-width: 950px)
  .display-badge
    display: none
    width: 0

</style>
